<template>
  <v-container fluid class="rbu-edition-detail" v-if="a_sor">
    <v-row class="flex-grow-0">
      <v-btn
        text
        color="primary"
        exact
        :to="{
          name: 'a-sor-rbu-section',
          params: { aSorId: a_sor.id },
        }"
      >
        <h3 class="font-weight-regular">&lt;&lt; A-Sor RBU Section</h3>
      </v-btn>
    </v-row>

    <v-row
      v-if="canEditConfig && !(a_sor && a_sor.finalised_at)"
      class="rbu-edition-info-wrapper"
      style="margin-bottom: 1rem"
    >
      <v-col>
        <h3>Configure: {{ a_sor.edition }}</h3>
      </v-col>
      <v-btn
        v-if="a_sor && !a_sor.updating_selected_rate"
        color="primary"
        @click="save"
        >Save
      </v-btn>
      <v-btn v-else color="primary" disabled
        >Updating Items: {{ a_sor.updated_item }}</v-btn
      >
    </v-row>

    <v-row v-else class="rbu-edition-info-wrapper" style="margin-bottom: 1rem">
    </v-row>

    <v-form>
      <v-text-field
        outlined
        type="text"
        :label="$t('rbu.rbu_edition_name')"
        v-model="a_sor.name"
        :rules="requiredRules"
        :disabled="
          (a_sor && a_sor.updating_selected_rate) ||
          !canEditConfig ||
          (a_sor && a_sor.finalised_at)
        "
      ></v-text-field>

      <v-select
        v-model="a_sor.selected_dataset"
        :items="dataset"
        chips
        label="Datasets"
        multiple
        outlined
        :disabled="
          (a_sor && a_sor.updating_selected_rate) ||
          !canEditConfig ||
          (a_sor && a_sor.finalised_at)
        "
      ></v-select>

      <ASorPeriodInput
        :label="$t('rbu.base_start')"
        v-model="a_sor.base_start"
        :rules="requiredRules"
        :disabled="
          (a_sor && a_sor.updating_selected_rate) ||
          !canEditConfig ||
          (a_sor && a_sor.finalised_at)
        "
        :min="min"
        :max="max"
      ></ASorPeriodInput>
      <ASorPeriodInput
        :label="$t('rbu.base_end')"
        v-model="a_sor.base_end"
        :rules="requiredRules"
        :disabled="
          (a_sor && a_sor.updating_selected_rate) ||
          !canEditConfig ||
          (a_sor && a_sor.finalised_at)
        "
        :min="min"
        :max="max"
      ></ASorPeriodInput>
      <!-- <v-text-field
        outlined
        type="number"
        min="0"
        step=".01"
        suffix="%"
        :label="$t('rbu.tcef')"
        v-model="a_sor.tcef"
        :rules="requiredRules"
        :disabled="(a_sor && a_sor.updating_selected_rate) || !canEditConfig"
      ></v-text-field> -->
      <v-text-field
        outlined
        type="number"
        min="0"
        step=".01"
        suffix="%"
        :label="$t('rbu.head_office_overhead_and_profit')"
        v-model="a_sor.head_office_overhead_and_profit"
        :rules="requiredRules"
        :disabled="
          (a_sor && a_sor.updating_selected_rate) ||
          !canEditConfig ||
          (a_sor && a_sor.finalised_at)
        "
      ></v-text-field>
    </v-form>
  </v-container>
</template>
<script>
import { ACTION_TYPES } from "@/store/types";
import {
  onMounted,
  onUnmounted,
  ref,
  computed,
  watch,
} from "@vue/composition-api";
import RbuSectionList from "@/components/rbu/RbuSectionList.vue";
import ASorPeriodInput from "@/components/asor/ASorPeriodInput.vue";
import { USER_TYPE } from "@/constants";

export default {
  name: "AsorRbuConfig",
  components: { ASorPeriodInput, RbuSectionList },
  setup(props, { root }) {
    const min = ref(undefined);
    const max = ref(undefined);
    const dataset = ref([]);

    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required") || value == "",
    ]);

    const a_sor = ref(null);
    const canEditConfig = computed(() => {
      if (!root.$store.getters.account) return false;
      return [USER_TYPE.SUPER_ADMIN, USER_TYPE.ADMIN].includes(
        root.$store.getters.account.type
      );
    });
    const getAsor = async function (force = false, not_blocking = true) {
      if (
        (a_sor.value && a_sor.value.updating_selected_rate === true) ||
        force
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/a_sor/",
          params: { a_sor_id: root.$route.params.aSorId },
          opt: { not_blocking },
        });
        if (response.body.success) {
          a_sor.value = response.body.a_sor;
          // a_sor.value.tcef = parseFloat(a_sor.value.tcef).toFixed(2);
          a_sor.value.head_office_overhead_and_profit = parseFloat(
            a_sor.value.head_office_overhead_and_profit
          ).toFixed(2);
        }
      }
    };

    const save = async function () {
      if (!a_sor.value) return;
      if (!a_sor.value.base_start) return;
      if (!a_sor.value.base_end) return;

      if (
        await root.$dialog.confirm({
          text: `Are you sure to update the master configure of this A-SoR - [${a_sor.value.name}]?`,
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/a_sor/edit_config/",
          params: {
            a_sor_id: root.$route.params.aSorId,
            ...a_sor.value,
          },
        });

        if (response.body.success) {
          if (response.body.failed) {
            let msg = "";
            response.body.failed.section_fluctuations.forEach((s) => {
              msg = msg + `Section ${s} Fluctuation\r\n`;
            });
            response.body.failed.items.forEach((i) => {
              msg = msg + `Item ${i}\r\n`;
            });

            if (msg.length > 0) {
              root.$store.dispatch(
                ACTION_TYPES.SHOW_SNACKBAR,
                `Failed to update:\r\n${msg}`
              );
            }
          }
          getAsor(true);
        }
      }
    };

    let refreshInterval = null;

    const getAvailablePeriod = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/available_data_period/",
        params: {
          datasets: a_sor.value.selected_dataset,
        },
      });

      if (response && response.data && response.data.success) {
        min.value = response.data.min;
        max.value = response.data.max;
      }
    };

    const getDataset = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/",
        params: {},
      });

      if (response && response.data && response.data.success) {
        dataset.value = response.data.datasets.map((d) => {
          return {
            text: `[${d.alias}]`,
            value: d.id,
          };
        });
      }
    };

    onMounted(() => {
      getAsor(true);
      getDataset();
      getAvailablePeriod();

      refreshInterval = setInterval(getAsor, 2500);
    });

    onUnmounted(() => {
      if (refreshInterval) {
        clearInterval(refreshInterval);
      }
    });

    watch(
      () => a_sor.value.selected_dataset,
      (newValue, _) => {
        getAvailablePeriod();
      }
    );

    return {
      requiredRules,
      canEditConfig,
      a_sor,

      save,
      min,
      max,
      dataset,
    };
  },
};
</script>

<style lang="less">
.rbu-edition-detail {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .rbu-edition-info-wrapper {
    flex: 0 0 auto;
    display: flex;

    .rbu-edition-info {
      flex: 1 1 0;
    }
  }
}
</style>
